import { render, staticRenderFns } from "./shared-models-list.html?vue&type=template&id=70cd50dc&scoped=true&external"
import script from "./shared-models-list.js?vue&type=script&lang=js&external"
export * from "./shared-models-list.js?vue&type=script&lang=js&external"
import style0 from "./shared-models-list.scss?vue&type=style&index=0&id=70cd50dc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd50dc",
  null
  
)

export default component.exports